<template lang="html">
  <input
    class="ui-upload-img"
    accept="image/*"
    type="file"
    :multiple="isMultiple"
    @change="onChange"
  />
</template>

<script>
import EXIF from 'exif-js'
import { UPLOAD_URL } from '@/config'

const hostname = (prefix = '') => {
  const hn = location.hostname
  return hn.indexOf('haiziwang.com') > -1
    ? `//${prefix}.haiziwang.com`
    : `//${prefix}.cekid.com`
}

export default {
  props: {
    // 是否支持多图
    isMultiple: {
      type: Boolean,
      default: true
    },
    // 多图时，剩余可上传几张
    rest: {
      type: Number,
      default: 3
    },
    // 每张图规定最大尺寸
    maxsize: {
      type: Number,
      default: 5 * 1024 * 1024 // 5 M 的图 (单位 B)
    },
    // 压缩图片质量 0-1 0.95 最佳 【http://www.tuicool.com/articles/zaIjInm】
    quality: {
      type: Number,
      default: 0.5
    },
    // 图片上传服务器地址
    url: {
      type: String,
      default: UPLOAD_URL
    },
    reload: Object
  },
  watch: {
    reload(value) {
      try {
        if (value && value.progress === 0 && value.fd) {
          this.upload(value)
        }
      } catch (e) {
        // console.log(e);
      }
    }
  },
  methods: {
    onChange(e) {
      try {
        const files = e.target.files || e.dataTransfer.files
        // fileList to fileArray
        let fileArray = Array.prototype.slice.call(files)
        fileArray = fileArray.slice(0, this.rest)
        const total = fileArray.length
        if (total) {
          if (typeof FileReader === 'undefined') {
            // 不支持文件上传
            this.$emit('input', {
              code: '1',
              msg: '您的浏览器不支持文件上传，请升级您的浏览器'
            })
            // 清空 input 值
            e.target.value = null
          } else {
            fileArray.forEach((v, i) => {
              const name = v.name
              const type = v.type
              if (!/\/(?:jpeg|jpg|png|gif|bmp|webp)/i.test(v.type)) {
                // 格式不支持
                this.$emit('input', {
                  code: 1,
                  msg: '文件格式不符合要求'
                })
                // 清空 input 值
                e.target.value = null
              } else {
                const size = v.size
                // 有的图片取到的size为0
                if (size > this.maxsize) {
                  // 文件过大
                  this.$emit('input', {
                    code: 2,
                    msg: '文件过大'
                  })
                } else if (size === 0) {
                  // 文件size=0
                  this.$emit('input', {
                    code: 1,
                    msg: '图片有误'
                  })
                } else {
                  // file 对象转 base64
                  this.readAsDataURL(v, total, i, new Date().getTime() + i)
                  // 清空 input 值
                  e.target.value = null
                }
              }
            })
          }
        }
      } catch (error) {
        console.log(new Error(error))
      }
    },
    readAsDataURL(file, total, index, id) {
      try {
        const reader = new FileReader()
        reader.onload = e => {
          // file 对象转 base64
          const src = e.target.result
          // base64 预览
          const pic = {
            total,
            index,
            id,
            src,
            name: file.name,
            width: 0,
            height: 0,
            progress: 0,
            finished: false,
            dataPic: '',
            fd: ''
          }
          this.$emit('input', {
            code: 3,
            msg: '预览',
            pic
          })
          setTimeout(() => {
            // 创建 img 对象
            const img = new Image()
            img.src = src
            img.onload = () => {
              pic.width = img.width
              pic.height = img.height
              // img 对象转 canvas
              const canvas = this.imgToCanvas(img)
              this.canvasResize(file, img, canvas, pic)
            }
          }, 0)
        }
        reader.onerror = e => {
          console.log(e)
        }
        reader.readAsDataURL(file)
      } catch (e) {
        console.log(new Error(e))
      }
    },
    imgToCanvas(img) {
      // 获取图片宽高
      const width = img.width
      const height = img.height
      // 定义 canvas
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height
      const ctx = canvas.getContext('2d')
      ctx.fillStyle = '#fff'
      ctx.fillRect(0, 0, width, height)
      ctx.drawImage(img, 0, 0, width, height, 0, 0, width, height)
      return canvas
    },
    canvasResize(file, img, canvas, pic) {
      try {
        EXIF.getData(img, () => {
          // 获取照片方向角属性，用户旋转控制
          const orientation = img.exifdata.Orientation
          // 获取图片宽高
          const width = img.width
          const height = img.height
          const ctx = canvas.getContext('2d')
          // 1 横着, 3 右斜, 6 左斜, 8 倒着
          if (orientation && orientation !== 1) {
            switch (orientation) {
              case 8:
                // 8 倒着拍, 需要逆时针（向左）90 度旋转，并交换宽高，水平
                canvas.width = height
                canvas.height = width
                ctx.rotate(-0.5 * Math.PI)
                ctx.translate(-1 * width, 0)
                break
              case 6:
                // 6 左斜或竖着拍, 需要顺时针（向右）90 度旋转
                canvas.width = height
                canvas.height = width
                ctx.rotate(0.5 * Math.PI)
                ctx.translate(0, -1 * height)
                break
              case 3:
                // 3 右斜, 需要顺时针（向右）180 度旋转
                ctx.rotate(Math.PI)
                ctx.translate(-1 * width, -1 * height)
                break
              case 1:
                // 1 正常
                ctx.rotate(0)
                break
              default:
                ctx.rotate(0)
            }
          }
          ctx.drawImage(img, 0, 0, width, height, 0, 0, width, height)
          let type
          if (/jpeg|webp/.test(file.type)) {
            type = file.type
          } else {
            type = 'image/jpeg'
          }
          const src = canvas.toDataURL(type, this.quality)
          // base64 转化为 blob
          this.dataURL2Blob(src, pic)
        })
      } catch (e) {
        console.log(new Error(e))
      }
    },
    arrayBufferToBlob(buffer, type) {
      let blob
      const Builder = window.BlobBuilder || window.WebKitBlobBuilder
      // android 不支持 new Blob, 只能借助 blobbuilder.
      if (Builder) {
        const bb = new Builder()
        bb.append(buffer)
        blob = bb.getBlob(type)
      }
      // ios
      blob = new Blob([buffer], type ? { type } : {})
      return blob
    },
    dataURL2Blob(src, pic) {
      try {
        // 先转为 buffer
        let byteStr
        const parts = src.split(',')
        if (parts[0].indexOf('base64') > 0) {
          byteStr = atob(parts[1])
        } else {
          byteStr = decodeURIComponent(parts[1])
        }
        const leng = byteStr.length
        const ab = new ArrayBuffer(leng)
        const uint8 = new Uint8Array(ab)
        for (let i = 0; i < leng; i += 1) {
          uint8[i] = byteStr.charCodeAt(i)
        }
        const mimetype = parts[0].split(':')[1].split(';')[0]
        // buffer 转 blob
        const blob = this.arrayBufferToBlob(ab, mimetype)
        const fd = new FormData()
        fd.append('file', blob, pic.name)
        pic.fd = fd
        // 上传
        this.upload(pic)
      } catch (e) {
        console.log(new Error(e))
      }
    },
    upload(pic) {
      try {
        let data
        const xhr = new XMLHttpRequest()
        xhr.withCredentials = true
        xhr.open('POST', `${this.url}`)
        if (/mobile/i.test(navigator.userAgent)) {
          // 移动端给个虚假 progress
          pic.progress = 0.5
          data = {
            code: 4,
            msg: '上传中',
            pic
          }
          this.$emit('input', data)
        } else {
          // PC chrome 支持，移动端不支持
          xhr.upload.onprogress = e => {
            if (e.lengthComputable) {
              pic.progress = e.loaded / e.total
              data = {
                code: 4,
                msg: '上传中',
                pic
              }
              this.$emit('input', data)
            }
          }
        }
        xhr.onload = e => {
          if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 0) {
            const res = JSON.parse(xhr.responseText)
            const code = res.code
            pic.progress = code === 0 ? 1 : 0
            pic.finished = true
            if (code === 0) {
              pic.dataPic = res.content && res.content.downloadUrl
              data = {
                code: 5,
                msg: '上传成功',
                pic
              }
            } else {
              pic.dataPic = ''
              data = {
                code: 6,
                msg: '上传失败',
                pic
              }
            }
          } else {
            pic.progress = 0
            pic.finished = true
            pic.dataPic = ''
            data = {
              code: 6,
              msg: '上传失败',
              pic
            }
          }
          this.$emit('input', data)
        }
        xhr.onerror = e => {
          pic.progress = 0
          pic.finished = true
          pic.dataPic = ''
          this.$emit('input', {
            code: 7,
            msg: '上传失败',
            pic
          })
        }
        xhr.send(pic.fd)
      } catch (e) {
        pic.progress = 0
        pic.finished = true
        pic.dataPic = ''
        this.$emit('input', {
          code: 8,
          msg: new Error(e),
          pic
        })
      }
    }
  }
}
</script>
